import ResumeForm from 'components/ResumeBuilder/ResumeForm';
import ResumePreview from 'components/ResumeBuilder/ResumePreview';
import ResumePreviewModal from 'components/ResumeBuilder/ResumePreviewModal';
import { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import './styles.scss';

const ResumeBuilder = () => {
	const [showModal, setShowModal] = useState(false);

	const handleShow = () => setShowModal(true);
	const handleClose = () => setShowModal(false);

	return (
		<div className="resume-template-preview position-relative overflow-hidden">
			<Row>
				<Col lg={6}>
					<ResumeForm />
				</Col>
				<Col lg={6} className="d-none d-lg-block">
					<ResumePreview />
				</Col>
			</Row>

			<div className="resume-preview-modal d-block d-lg-none position-fixed">
				<Button variant="primary" onClick={handleShow} className="border-0 p-0">
					<i className="ri-eye-fill"></i>
				</Button>

				<ResumePreviewModal showModal={showModal} handleClose={handleClose} />
			</div>
		</div>
	);
};

export default ResumeBuilder;
